import gDataJSONOneImport from './gdata.one.json';
import gDataJSONPreImport from './gdata.pre.json';
import gDataJSONValue1Import from './gdata.value1.json';
import gDataJSONValue2Import from './gdata.value2.json';
import gDataJSONValue3Import from './gdata.value3.json';

let gDataJSONOne = gDataJSONOneImport.data;
let gDataJSONPre = gDataJSONPreImport.data;
let gDataJSONValue1 = gDataJSONValue1Import.data;
let gDataJSONValue2 = gDataJSONValue2Import.data;
let gDataJSONValue3 = gDataJSONValue3Import.data;

let unique_id = 0;

let getUniQueId = () => {
    unique_id++;
    return '__' + unique_id + '_' + Date.now() + '_' + Math.random().toString(36).substr(2) + '__';
};

let mergeGraph = (...graphs) => {
    let g = {nodes: [], links: []};
    graphs.forEach((item) => {
        g.nodes = [...g.nodes, ...item.nodes];
        g.links = [...g.links, ...item.links]
    });
    return g;
};

let cloneGraph = (graph) => {
    let g = JSON.parse(JSON.stringify(graph));
    let _id = getUniQueId();
    g.nodes.forEach(_ => _.id += _id);
    g.links.forEach(_ => (_.target += _id) && (_.source += _id));
    return g;
};

let copyGraph = (graph, num) => {
    let gArr = [];
    for (let i = 0; i < num; i++) {
        gArr.push(cloneGraph(graph));
    }
    return mergeGraph(...gArr);
};

let oneGraph = (num = 100) => {
    let _id = getUniQueId();
    let nodes = [...Array(num).keys()].map(i => ({ id: i+_id, group: i+Date.now(), name: '1' }));
    return {nodes: nodes, links: []};
};

let makeGraph = (num) => {
    let _id = getUniQueId();
    let nodes = [...Array(num).keys()].map(i => ({ id: i+_id, group: i+_id, name: '' }));
    let links = [];
    let source = nodes[0].id;
    for (let i = 1; i < nodes.length; i++) {
        links.push({
            source: source,
            target: nodes[i].id,
        })
    }
    return {nodes: nodes, links: links};
};

let exportObj = {
    cloneGraph, mergeGraph, oneGraph, copyGraph, makeGraph,
    onePoi: () => gDataJSONOne,
    v1Graph: () => cloneGraph(gDataJSONValue1),
    v2Graph: () => cloneGraph(gDataJSONValue2),
    v3Graph: () => cloneGraph(gDataJSONValue3),
};

export default exportObj;


// id混乱化
// [gDataJSONOne, gDataJSONPre, gDataJSONValue1, gDataJSONValue2, gDataJSONValue3].forEach((item, index) => {
//     item.nodes = item.nodes.map(_ => {
//         _.id += index;
//         return _;
//     });
//     item.links = item.links.map(_ => {
//         _.source += index;
//         _.target += index;
//         return _;
//     });
// });
